import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "capacity_planning_colored",
  "use": "capacity_planning_colored-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"capacity_planning_colored\"><path fill=\"#FFEFD9\" stroke=\"#FFD08C\" d=\"M1 12.5h3v2H1zM6 6.5h3v8H6zM11 .5h3v14h-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol